/**
 * @fileoverview PATCH handler for the "/apps/catalogs/:catalog_id/filtered_sets/:filtered_set_name" endpoint
 */
import fetch from "@lib/fetch";

import type { PostAppsCatalogsCatalogIdFilteredSetsProps } from "../appsCatalogsCatalogIdFilteredSets";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsCatalogIdFilteredSetsFilteredSetNameCacheKeys } from "./constants";
import type { AppsCatalogsCatalogIdFilteredSetsFilteredSetNameResult } from "./types";

export const patchAppsCatalogsCatalogIdFilteredSetsFilteredSetName = reactQueryMutationAdapter(
  appsCatalogsCatalogIdFilteredSetsFilteredSetNameCacheKeys,
  ({
    catalogId,
    name,
    description,
    filters,
    resultsLimit,
    sortField,
    sortOrder,
  }: PostAppsCatalogsCatalogIdFilteredSetsProps): Promise<AppsCatalogsCatalogIdFilteredSetsFilteredSetNameResult> => {
    return fetch(
      `/apps/catalogs/${catalogId}/filtered_sets/${name}`,
      "PATCH",
      {
        catalog_id: catalogId,
        name,
        description,
        filters,
        results_limit: resultsLimit,
        sort_field: sortField,
        sort_order: sortOrder,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
